
import React from 'react'
import { Animated } from 'react-web-animation'

export default class RoomS extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 1051,
      originalHeight: 944
    }
    this.state = {
      ...this.state,
      width: parseFloat(props.width),
      height: this.state.originalHeight / (this.state.originalWidth / parseFloat(props.width)),
      ratio: this.state.originalWidth / parseFloat(props.width)
    }
  }
  render() {
    return (
      <div>
        <svg height={this.state.height} width={this.state.width} viewBox={`0 0 ${this.state.originalWidth} ${this.state.originalHeight}`}>
        <defs>
            <polygon id="path-1" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-2" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-3" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-4" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-5" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
            <polygon id="path-6" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-7" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-8" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-9" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-10" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
            <polygon id="path-11" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-12" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-13" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-14" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-15" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
            <polygon id="path-16" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-17" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-18" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-19" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-20" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
            <polygon id="path-21" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-22" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-23" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-24" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-25" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
            <polygon id="path-26" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
            <polygon id="path-27" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
            <polygon id="path-28" points="116.606528 521.490609 209.78541 505.24136 193.536161 598.420242 100.35728 614.66949"/>
            <polygon id="path-29" points="40.0068373 575.110392 133.185719 558.861144 116.936471 652.040025 23.757589 668.289274"/>
            <polygon id="path-30" points="193.206219 467.870825 286.385101 451.621577 270.135852 544.800458 176.956971 561.049707"/>
            <polygon id="path-31" points="269.80591 414.251041 362.984792 398.001793 346.735543 491.180675 253.556662 507.429923"/>
            <polygon id="path-32" points="345.31132 360.631258 438.490201 344.382009 422.240953 437.560891 329.062071 453.810139"/>
            <polygon id="path-33" points="421.91101 307.011474 515.089892 290.762226 498.840644 383.941107 405.661762 400.190356"/>
            <polygon id="path-34" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
            <polygon id="path-35" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
            <polygon id="path-36" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
          </defs>
          <g id="Packages/S" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
            <polygon id="Rectangle-8" fill="#DFDFDF" points="102.053551 186.471789 662.179041 187.614363 491.324624 431.5908 -68.8008666 430.448226" transform="translate(296.689087, 309.031295) rotate(-35.000000) translate(-296.689087, -309.031295) "/>
            <polygon id="Rectangle-8" fill="#929292" points="560.420622 189.890225 1122.50615 190.676415 951.806817 435.009236 390.067201 433.72792" transform="translate(756.286676, 312.449731) scale(-1, 1) rotate(-35.000000) translate(-756.286676, -312.449731) "/>
            <g id="Boden/6x6" transform="translate(-240.000000, 275.000000)">
              <g id="10m" transform="translate(381.904173, 214.479134)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
              <g id="10m" transform="translate(305.304482, 268.098918)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
              <g id="10m" transform="translate(458.503864, 160.859351)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
              <g id="10m" transform="translate(535.103555, 107.239567)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
              <g id="10m" transform="translate(610.608964, 53.619784)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
              <g id="10m" transform="translate(687.208655, 0.000000)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(77.377373, 77.377373) rotate(45.000000) translate(-77.377373, -77.377373) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="38.912556 38.912556 132.091438 22.6633077 115.842189 115.842189 22.6633077 132.091438"/>
                  <path d="M39.3854815,39.3854815 L23.336018,131.418727 L115.369264,115.369264 L131.418727,23.336018 L39.3854815,39.3854815 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 291.856507) rotate(45.000000) translate(-383.776136, -291.856507) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 253.39169 438.490201 237.142442 422.240953 330.321324 329.062071 346.570572"/>
                  <path d="M345.784245,253.864616 L329.734782,345.897862 L421.768027,329.848398 L437.817491,237.815152 L345.784245,253.864616 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(155.071345, 559.955425) rotate(45.000000) translate(-155.071345, -559.955425) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="116.606528 521.490609 209.78541 505.24136 193.536161 598.420242 100.35728 614.66949"/>
                  <path d="M117.079454,521.963534 L101.02999,613.99678 L193.063236,597.947316 L209.112699,505.914071 L117.079454,521.963534 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(78.471654, 613.575209) rotate(45.000000) translate(-78.471654, -613.575209) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="40.0068373 575.110392 133.185719 558.861144 116.936471 652.040025 23.757589 668.289274"/>
                  <path d="M40.4797628,575.583318 L24.4302993,667.616563 L116.463545,651.5671 L132.513009,559.533854 L40.4797628,575.583318 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(231.671036, 506.335642) rotate(45.000000) translate(-231.671036, -506.335642) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="193.206219 467.870825 286.385101 451.621577 270.135852 544.800458 176.956971 561.049707"/>
                  <path d="M193.679145,468.34375 L177.629681,560.376996 L269.662927,544.327533 L285.71239,452.294287 L193.679145,468.34375 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(308.270727, 452.715858) rotate(45.000000) translate(-308.270727, -452.715858) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="269.80591 414.251041 362.984792 398.001793 346.735543 491.180675 253.556662 507.429923"/>
                  <path d="M270.278835,414.723967 L254.229372,506.757213 L346.262618,490.707749 L362.312081,398.674503 L270.278835,414.723967 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(383.776136, 399.096074) rotate(45.000000) translate(-383.776136, -399.096074) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="345.31132 360.631258 438.490201 344.382009 422.240953 437.560891 329.062071 453.810139"/>
                  <path d="M345.784245,361.104183 L329.734782,453.137429 L421.768027,437.087965 L437.817491,345.05472 L345.784245,361.104183 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(460.375827, 345.476291) rotate(45.000000) translate(-460.375827, -345.476291) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="421.91101 307.011474 515.089892 290.762226 498.840644 383.941107 405.661762 400.190356"/>
                  <path d="M422.383936,307.4844 L406.334472,399.517645 L498.367718,383.468182 L514.417182,291.434936 L422.383936,307.4844 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(230.576754, 184.616940) rotate(45.000000) translate(-230.576754, -184.616940) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="192.111938 146.152123 285.290819 129.902875 269.041571 223.081757 175.86269 239.331005"/>
                  <path d="M192.584863,146.625049 L176.5354,238.658295 L268.568646,222.608831 L284.618109,130.575585 L192.584863,146.625049 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(153.977064, 130.997156) rotate(45.000000) translate(-153.977064, -130.997156) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="115.512247 92.5323396 208.691128 76.2830914 192.44188 169.461973 99.2629986 185.711221"/>
                  <path d="M115.985172,93.0052651 L99.9357089,185.038511 L191.968955,168.989047 L208.018418,76.9558016 L115.985172,93.0052651 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="translate(307.176445, 238.236724) rotate(45.000000) translate(-307.176445, -238.236724) ">
                  <polygon fill="#D8D8D8" fillRule="evenodd" points="268.711629 199.771907 361.89051 183.522659 345.641262 276.70154 252.46238 292.950788"/>
                  <path d="M269.184554,200.244832 L253.135091,292.278078 L345.168336,276.228615 L361.2178,184.195369 L269.184554,200.244832 Z" stroke="#979797" strokeWidth="1.0942813"/>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <Desk ratio={ this.state.ratio } />
        <Pretreat ratio={ this.state.ratio } />
        <Press2 ratio={ this.state.ratio } />
        <Press1 ratio={ this.state.ratio } />
        <Gtx1 ratio={ this.state.ratio } />
        <Gtx2 ratio={ this.state.ratio } />
        <Senddesk ratio={ this.state.ratio } />
      </div>
    )
  }
}

class Gtx1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 385,
      originalHeight: 274,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 510 / this.state.ratio, left: 601 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 385,
      originalHeight: 274,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 402 / this.state.ratio, left: 449 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/gtx.png")} />
    )
  }
}

class Senddesk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 309,
      originalHeight: 248,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 591 / this.state.ratio, left: 371 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/senddesk.png")} />
    )
  }
}

class Desk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 309,
      originalHeight: 218,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 458 / this.state.ratio, left: 143 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/desk.png")} />
    )
  }
}

class Press1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 233,
      originalHeight: 341,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 340 / this.state.ratio, left: 295 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/press.png")} />
    )
  }
}

class Press2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 233,
      originalHeight: 341,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 285 / this.state.ratio, left: 372 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/press.png")} />
    )
  }
}

class Pretreat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 233,
      originalHeight: 243,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
    return [
        { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
        { opacity: 1, offset: 1 },
        { transform: 'translateY(0)', opacity: 1, offset: 1 }
    ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 241 / this.state.ratio, left: 444 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: 'auto' }} src={require("./devices/pretreat.png")} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/room/rooms/S.js